var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-form-item",
    { attrs: { prop: "name", rules: _vm.nameRequiredRule } },
    [
      _c(
        "span",
        { attrs: { slot: "label" }, slot: "label" },
        [
          _vm._v(_vm._s(_vm.i18nt("designer.setting.uniqueName")) + "\n    "),
          _c(
            "el-tooltip",
            {
              attrs: {
                effect: "light",
                content: _vm.i18nt("designer.setting.editNameHelp"),
              },
            },
            [_c("i", { staticClass: "el-icon-info" })]
          ),
        ],
        1
      ),
      _vm._v(" "),
      (!!_vm.selectedWidget.category &&
        _vm.selectedWidget.type !== "sub-form") ||
      _vm.noFieldList
        ? [
            _c("el-input", {
              attrs: { type: "text", readonly: _vm.widgetNameReadonly },
              on: { change: _vm.updateWidgetNameAndRef },
              model: {
                value: _vm.optionModel.name,
                callback: function ($$v) {
                  _vm.$set(_vm.optionModel, "name", $$v)
                },
                expression: "optionModel.name",
              },
            }),
          ]
        : [
            _c(
              "el-select",
              {
                attrs: {
                  "allow-create": "",
                  filterable: "",
                  disabled: _vm.widgetNameReadonly,
                  title: _vm.i18nt("designer.setting.editNameHelp"),
                },
                on: { change: _vm.updateWidgetNameAndRef },
                model: {
                  value: _vm.optionModel.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.optionModel, "name", $$v)
                  },
                  expression: "optionModel.name",
                },
              },
              _vm._l(_vm.serverFieldList, function (sf, sfIdx) {
                return _c("el-option", {
                  key: sfIdx,
                  attrs: { label: sf.label, value: sf.name },
                })
              }),
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }